module.exports = __webpack_public_path__ + "static/media/bar-chart-2.38870eba.svg";